<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      :mini-variant="mini"
      clipped
      fixed
      permanent
      app
      width="250"
      class="fixbar"
    >
      <v-list class="hover-inverted green">
        <v-list-tile>
          <v-list-tile-action class="pointer" @click.stop="mini = !mini">
            <img src="@/assets/uv-logo-02.png" width="50px" />
          </v-list-tile-action>
          <v-list-tile>
            <img src="@/assets/uv-logo-01.png" width="120px" />
          </v-list-tile>
        </v-list-tile>
      </v-list>

      <v-divider light></v-divider>

      <div v-if="!mini">
        <v-list class="pt-0" dense>
          <v-divider light></v-divider>

          <router-link to="/" exact>
            <v-list-tile @click="mini = !mini">
              <v-list-tile-action>
                <v-icon>mdi-home-outline</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>
                <v-list-tile-title>Home</v-list-tile-title>
              </v-list-tile-title>
            </v-list-tile>
          </router-link>

          <router-link to="/topup" exact>
            <v-list-tile @click="mini = !mini">
              <v-list-tile-action>
                <v-icon> mdi-cash-plus</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>
                <v-list-tile-title>Top Up</v-list-tile-title>
              </v-list-tile-title>
            </v-list-tile>
          </router-link>

          <v-list-group prepend-icon="mdi-file-outline">
            <v-list-tile slot="activator">
              <v-list-tile-title>Report</v-list-tile-title>
            </v-list-tile>

            <router-link
              to="/transaction"
              exact
              title="Purchase With API and Manual"
            >
              <v-list-tile @click="mini = !mini" class="pl-4">
                <v-list-tile-action>
                  <v-icon>mdi-file-chart</v-icon>
                </v-list-tile-action>
                <v-list-tile-title>
                  <v-list-tile-title
                    >Purchase With API and Manual</v-list-tile-title
                  >
                </v-list-tile-title>
              </v-list-tile>
            </router-link>

            <router-link
              to="/transaction-v2"
              exact
              title="Purchase With Direct Customer Delivery"
            >
              <v-list-tile @click="mini = !mini" class="pl-4">
                <v-list-tile-action>
                  <v-icon>mdi-file-check</v-icon>
                </v-list-tile-action>
                <v-list-tile-title>
                  <v-list-tile-title
                    >Purchase With Direct Customer Delivery</v-list-tile-title
                  >
                </v-list-tile-title>
              </v-list-tile>
            </router-link>

            <router-link
              to="/dtc-success"
              exact
              title="Report Direct to Customer"
            >
              <v-list-tile @click="mini = !mini" class="pl-4">
                <v-list-tile-action>
                  <v-icon>mdi-file-document</v-icon>
                </v-list-tile-action>
                <v-list-tile-title>
                  <v-list-tile-title
                    >Report Direct to Customer</v-list-tile-title
                  >
                </v-list-tile-title>
              </v-list-tile>
            </router-link>

            <router-link
              to="/balance-history"
              exact
              title="Transaction History"
            >
              <v-list-tile @click="mini = !mini" class="pl-4">
                <v-list-tile-action>
                  <v-icon>mdi-credit-card-settings</v-icon>
                </v-list-tile-action>
                <v-list-tile-title>
                  <v-list-tile-title>Transaction History</v-list-tile-title>
                </v-list-tile-title>
              </v-list-tile>
            </router-link>

            <router-link to="/voucher-usage" exact title="Voucher Status">
              <v-list-tile @click="mini = !mini" class="pl-4">
                <v-list-tile-action>
                  <v-icon>mdi-ticket-confirmation</v-icon>
                </v-list-tile-action>
                <v-list-tile-title>
                  <v-list-tile-title>Voucher Status</v-list-tile-title>
                </v-list-tile-title>
              </v-list-tile>
            </router-link>

            <router-link to="/callback" exact title="Callback">
              <v-list-tile @click="mini = !mini" class="pl-4">
                <v-list-tile-action>
                  <v-icon>mdi-call-missed</v-icon>
                </v-list-tile-action>
                <v-list-tile-title>
                  <v-list-tile-title>Callback</v-list-tile-title>
                </v-list-tile-title>
              </v-list-tile>
            </router-link>
          </v-list-group>

          <v-list-group prepend-icon="mdi-bookmark-outline">
            <v-list-tile slot="activator">
              <v-list-tile-title>Catalog</v-list-tile-title>
            </v-list-tile>

            <router-link to="/brand" exact title="Merchant Catalog">
              <v-list-tile @click="mini = !mini" class="pl-4">
                <v-list-tile-action>
                  <v-icon>mdi-book-open-page-variant</v-icon>
                </v-list-tile-action>
                <v-list-tile-title>
                  <v-list-tile-title>Merchant Catalog</v-list-tile-title>
                </v-list-tile-title>
              </v-list-tile>
            </router-link>

            <router-link to="/product" exact title="Voucher Catalog">
              <v-list-tile @click="mini = !mini" class="pl-4">
                <v-list-tile-action>
                  <v-icon>mdi-package-variant-closed</v-icon>
                </v-list-tile-action>
                <v-list-tile-title>
                  <v-list-tile-title>Voucher Catalog</v-list-tile-title>
                </v-list-tile-title>
              </v-list-tile>
            </router-link>
          </v-list-group>

          <v-list-group prepend-icon="mdi-playlist-edit">
            <v-list-tile slot="activator">
              <v-list-tile-title>Order</v-list-tile-title>
            </v-list-tile>

            <router-link to="/order" exact title="Purchase With API and Manual">
              <v-list-tile @click="mini = !mini" class="pl-4">
                <v-list-tile-action>
                  <v-icon>mdi-playlist-edit</v-icon>
                </v-list-tile-action>
                <v-list-tile-title>
                  <v-list-tile-title
                    >Purchase With API and Manual</v-list-tile-title
                  >
                </v-list-tile-title>
              </v-list-tile>
            </router-link>

            <router-link
              to="/order-v2"
              exact
              title="Purchase With Direct Customer Delivery"
            >
              <v-list-tile @click="mini = !mini" class="pl-4">
                <v-list-tile-action>
                  <v-icon>mdi-square-edit-outline</v-icon>
                </v-list-tile-action>
                <v-list-tile-title>
                  <v-list-tile-title
                    >Purchase With Direct Customer Delivery</v-list-tile-title
                  >
                </v-list-tile-title>
              </v-list-tile>
            </router-link>
          </v-list-group>
        </v-list>
      </div>

      <div v-else>
        <v-list>
          <v-list>
            <v-menu
              open-on-hover
              :close-delay="100"
              right
              offset-x
              :nudge-right="5"
              :nudge-width="180"
            >
              <router-link to="/" exact slot="activator">
                <v-icon color="grey" class="activicon" dark>
                  mdi-home-outline
                </v-icon>
              </router-link>

              <router-link to="/" exact class="mini-hover">
                <v-list-tile class="white mini-text">
                  <v-icon class="mr-3 mini-icon">mdi-home-outline</v-icon>Home
                </v-list-tile>
              </router-link>
            </v-menu>
          </v-list>
          <v-list>
            <v-menu
              open-on-hover
              :close-delay="100"
              right
              offset-x
              :nudge-right="5"
              :nudge-width="180"
            >
              <router-link to="/topup" exact slot="activator">
                <v-icon color="grey" class="activicon" dark>
                  mdi-cash-plus
                </v-icon>
              </router-link>

              <router-link to="/topup" exact class="mini-hover">
                <v-list-tile class="white mini-text">
                  <v-icon class="mr-3 mini-icon">mdi-cash-plus</v-icon>Top Up
                </v-list-tile>
              </router-link>
            </v-menu>
          </v-list>

          <v-list>
            <v-menu
              open-on-hover
              :close-delay="100"
              right
              offset-x
              :nudge-right="10"
              :nudge-width="180"
            >
              <v-icon color="grey" class="activicon" dark slot="activator">
                mdi-file-outline
              </v-icon>

              <router-link to="/transaction" exact class="mini-hover">
                <v-list-tile class="white mini-text">
                  <v-icon class="mr-3 mini-icon">mdi-file-chart</v-icon>Purchase
                  With API and Manual
                </v-list-tile>
              </router-link>
              <router-link to="/transaction-v2" exact class="mini-hover">
                <v-list-tile class="white mini-text">
                  <v-icon class="mr-3 mini-icon">mdi-file-check</v-icon>Purchase
                  With Direct Customer Delivery
                </v-list-tile>
              </router-link>
              <router-link to="/dtc-success" exact class="mini-hover">
                <v-list-tile class="white mini-text">
                  <v-icon class="mr-3 mini-icon">mdi-file-document</v-icon>Report
                  Direct to Customer
                </v-list-tile>
              </router-link>

              <router-link to="/balance-history" exact class="mini-hover">
                <v-list-tile class="white mini-text">
                  <v-icon class="mr-3 mini-icon"
                    >mdi-credit-card-settings</v-icon
                  >Transaction History
                </v-list-tile>
              </router-link>

              <router-link to="/voucher-usage" exact class="mini-hover">
                <v-list-tile class="white mini-text">
                  <v-icon class="mr-3 mini-icon">mdi-ticket-confirmation</v-icon
                  >Voucher Status
                </v-list-tile>
              </router-link>

              <router-link to="/callback" exact class="mini-hover">
                <v-list-tile class="white mini-text">
                  <v-icon class="mr-3 mini-icon">mdi-call-missed</v-icon>Callback
                </v-list-tile>
              </router-link>
            </v-menu>
          </v-list>

          <v-list>
            <v-menu
              open-on-hover
              :close-delay="100"
              right
              offset-x
              :nudge-right="10"
              :nudge-width="180"
            >
              <v-icon color="grey" class="activicon" dark slot="activator">
                mdi-bookmark-outline
              </v-icon>

              <router-link to="/brand" exact class="mini-hover">
                <v-list-tile class="white mini-text">
                  <v-icon class="mr-3 mini-icon"
                    >mdi-book-open-page-variant</v-icon
                  >Merchant Catalog
                </v-list-tile>
              </router-link>

              <router-link to="/product" exact class="mini-hover">
                <v-list-tile class="white mini-text">
                  <v-icon class="mr-3 mini-icon"
                    >mdi-package-variant-closed</v-icon
                  >Voucher Catalog
                </v-list-tile>
              </router-link>
            </v-menu>
          </v-list>

          <v-list>
            <v-menu
              open-on-hover
              :close-delay="100"
              right
              offset-x
              :nudge-right="5"
              :nudge-width="180"
            >
              <v-icon color="grey" class="activicon" dark slot="activator">
                mdi-playlist-edit
              </v-icon>

              <router-link to="/order" exact class="mini-hover">
                <v-list-tile class="white mini-text">
                  <v-icon class="mr-3 mini-icon">mdi-playlist-edit</v-icon
                  >Purchase With API and Manual
                </v-list-tile>
              </router-link>

              <router-link to="/order-v2" exact class="mini-hover">
                <v-list-tile class="white mini-text">
                  <v-icon class="mr-3 mini-icon">mdi-square-edit-outline</v-icon
                  >Purchase With Direct Customer Delivery
                </v-list-tile>
              </router-link>
            </v-menu>
          </v-list>
        </v-list>
      </div>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Sidebar',
  data: () => ({
    drawer: true,
    right: null,
    logo: 'https://ultravoucher.co.id/wp-content/uploads/2018/03/Logo-Ultra-Voucher-basic.png'
  }),
  computed: {
    ...mapState(['username', 'logo_cl']),
    mini: {
      get: function () {
        return this.$store.getters.getMini
      },
      set: function (newValue) {
        this.$store.commit('setMini', newValue)
      }
    }
  }
}
</script>

<style scoped>
.v-list__tile__title,
.mini-hover .mini-text {
  font-size: 14px;
  color: #73818f;
  padding: 2px 0;
}

.activicon:hover {
  color: rgb(77, 189, 153) !important;
  font-weight: 600;
}

.router-link-active .v-list__tile__content,
.router-link-active .v-list__tile__title,
.router-link-active .v-list__tile__action i.v-icon,
.hover-inverted .v-list__tile:hover .v-list__tile__action i.v-icon {
  color: rgb(77, 189, 153);
  font-weight: 600;
}

.v-list__tile:hover .v-list__tile__title,
.v-list__tile:hover .v-list__tile__action i.v-icon,
.mini-hover:hover .mini-text,
.mini-hover:hover .mini-icon {
  color: white;
  font-weight: 600;
}

.v-navigation-drawer a:hover div[role="listitem"],
.mini-hover:hover .mini-text {
  background: rgb(77, 189, 153) !important;
}

.v-list__tile__action i.v-icon,
.mini-hover .mini-icon,
.activicon {
  color: #73818f;
  display: inline-block;
  width: 1.09375rem;
  margin: 0 0.5rem 0 0;
  font-size: 1.4rem;
  text-align: center;
}

.mini-icon {
  margin-top: -8px !important;
}

.menu-btn {
  position: absolute;
  top: 1.25rem;
  left: 1.5rem;
  height: auto;
}

.menu-btn:hover {
  transform: scale(1.2);
  cursor: pointer;
}

.close-btn {
  position: fixed;
  z-index: 100;
  left: 0;
  margin-left: 230px;
  top: 0;
  margin-top: 15px;
}

.fixbar {
  z-index: 20;
  position: fixed;
}
.green {
  color: white !important;
}
</style>
